import { getToken } from "utils/helper";
import { logger } from "utils/logger";

export const getAssetByTimeline = async (criteria) => {
  var url = `${process.env.REACT_APP_API_URL}/assets/timeline?`;

  if (criteria && criteria.dayStart) {
    url += `daystart=${criteria.dayStart}`;
  }

  logger.log(" GETTING asset DATA: ");
  return fetch(url, {
    headers: {
      onset: getToken(),
    },
    method: "GET",
    // body: formData,
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      var items = data.Items.filter(tmpItem => tmpItem.assignedSequence.length).map((item, idx) => {
        var newItem = item;
        // newItem = new SampleModel(item);
        newItem.id = `${newItem.style}-${newItem.assignedSequence}`;
        return newItem;
      });
      return items;
    })
    .catch((err) => {
      logger.error("ERROR getting assets", err);
      throw err;
    });
};
